import React, { useCallback } from 'react'
import styled from 'styled-components'

import { ArtworksProps } from '../../constants/artwork'

// components
import APlayerModal from './APlayerModal'

// utils
import { stopPropagation } from '../../utils/func'

// hooks
import useModal from '../../hooks/bakery/useModal'

const CardAPlayer = styled.div<{size?: string, img?: string}>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({size}) => size ? '500px' : '100%'};
  height: ${({size}) => size ? '500px' : '100%'};
  .defalt {
    width: 100%;
    height: 100%;
    background-image: url(${({img}) => img ? img : ''});
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    border-radius: 28px;
  }
  & > div {
    position: relative;
  }
  .cover {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0;
    left: 0;
    width: ${({size}) => size ? '500px' : '100%'};
    height: ${({size}) => size ? '500px' : '100%'};
    border-radius: 28px;
    background: rgba(0, 0, 0, 0.5);
    cursor: pointer;
    transition: background .2s linear;
    overflow: hidden;
  }
`
const CardImageDiv = styled.div`
  width: auto;
  height: auto;
  .cover {
    width: 100%!important;
    height: 100%!important;
  }
`
const CardImage = styled.img`
  display: block;
  max-width: 100%;
  max-height: 100%;
  border-radius: 28px;
  object-fit: contain;
  cursor: pointer;
  overflow: hidden;
`
export default function Player({history, player, isMyArtwork, status, canReview, type, size, tokenName}: {history: any, player: ArtworksProps, isMyArtwork?: boolean, status: number, canReview: boolean, type: string, size?: string, tokenName?: string}) {
  
  const [artworkPlay] = useModal(
    <APlayerModal
      history={history}
      video={player}
      isMyArtwork={isMyArtwork}
      status={status}
      canReview={canReview}
      type={type}
      size={size}
      tokenName={tokenName}
    />
  )
  const onPresentPlayer = useCallback(async (event: any) => {
    stopPropagation(event)
    artworkPlay()
  }, [artworkPlay])

  return (
    <CardAPlayer size={size} img={player.attributes.cover_url}>
      {
        size ? (
          <CardImageDiv>
            <CardImage src={player.attributes.cover_url} alt="">
            </CardImage>
            <div className="cover" onClick={onPresentPlayer}>
              <img className="bgImg" src="images/artworks/aplayer.svg" alt=""/>
            </div>
          </CardImageDiv>
        ) : (
          <>
            <div className="defalt"></div>
            <div className="cover" onClick={onPresentPlayer}>
              <img className="bgImg" src="images/artworks/aplayer.svg" alt=""/>
            </div>
          </>
        )
      }
    </CardAPlayer>
  )
}
